import React from 'react';

import InfoIcon from 'icons/info.svg';
import { Trans } from 'react-i18next';

export default function TeamsAccessExplanationNotification() {
  return (
    <div className='tw-mb-6 tw-mt-12 tw-flex tw-rounded-lg tw-border-0 tw-bg-cyan-025 tw-p-3 tw-text-cyan-800'>
      <div className='tw-mr-3 tw-h-5'>
        <InfoIcon
          className='[&_path]:tw-fill-cyan-800'
          height={20}
          width={20}
        />
      </div>
      <p className='tw-m-0'>
        <Trans
          components={{
            a: (
              /* eslint-disable jsx-a11y/anchor-has-content */
              <a
                className='tw-text-cyan-600 hover:tw-text-cyan-800'
                href='https://intercom.help/hands-hq/en/articles/9210497-teams-for-training-register-overview'
                rel='noopener noreferrer'
                target='_blank'
              />
              /* eslint-enable jsx-a11y/anchor-has-content */
            ),
          }}
          i18nKey='settings.users.TeamsAccessExplanationNotification.description'
          ns='components'
        />
      </p>
    </div>
  );
}
